import React from 'react';
import { ShieldCheckIcon, ZapIcon, ClockIcon, CalendarCheckIcon } from 'lucide-react';
export function TrustStrip() {
  const items = [{
    icon: ShieldCheckIcon,
    text: 'Free Consultation Available'
  }, {
    icon: ZapIcon,
    text: 'Aspen Pinnacle Technology'
  }, {
    icon: ClockIcon,
    text: 'No Downtime for Most Patients'
  }, {
    icon: CalendarCheckIcon,
    text: 'Same-Week Openings May Be Available'
  }];
  return <div className="bg-white border-y border-gray-200 py-3 md:py-4" data-id="element-275">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-277">
          {items.map((item, idx) => <div key={idx} className="flex items-center gap-2 md:justify-center text-brand-navy" data-id="element-278">
              <div className="w-7 h-7 bg-brand-teal/10 rounded-md flex items-center justify-center flex-shrink-0" data-id="element-279">
                <item.icon className="w-4 h-4 text-brand-teal" data-id="element-280" />
              </div>
              <span className="font-bold text-xs md:text-sm leading-tight" data-id="element-281">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}